import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

const Disclaimer = () => {
  return (
    <div
      className="relative mt-8 border-t border-[var(--sd-border)] bg-[var(--sd-surface)] py-6 px-4 pb-28 lg:pb-6 z-10"
      data-testid="disclaimer-footer"
    >
      <div className="max-w-6xl mx-auto space-y-4">
        <div className="flex items-start gap-3 text-sm text-[var(--sd-fg-secondary)] leading-relaxed">
          <AlertCircle size={18} className="flex-shrink-0 mt-0.5 text-[var(--sd-primary)]" />
          <p>
            <span className="font-semibold text-[var(--sd-fg)]">Disclaimer:</span>{' '}
            Selah Downloads™ provides a platform for spiritual reflection and
            divine guidance based on biblical principles. Content is for
            spiritual and educational purposes and is not a substitute for
            professional mental health, legal, or financial counseling.
            Monthly subscriptions can be managed from your account settings
            and cancelled at any time.
          </p>
        </div>

        <div
          className="border-t border-[var(--sd-border)] pt-4 space-y-3 text-xs text-[var(--sd-muted-fg)]"
          data-testid="disclaimer-legal-line"
        >
          <div className="space-y-1.5 leading-relaxed">
            <p className="text-center sm:text-left">
              © 2026{' '}
              <span className="font-medium text-[var(--sd-fg-secondary)]">
                Selah &amp; Stone Legacy Holdings LLC
              </span>
              .
            </p>
            <p className="text-center sm:text-left">
              Selah Downloads™, Selah Slate™, Selah Rest™, and Selah &amp; Salt Home™ are proprietary trademarks of Selah &amp; Stone Legacy Holdings LLC.
            </p>
            <p className="text-center sm:text-left">
              All rights reserved. Unauthorized reproduction or reverse engineering of this software codebase is strictly prohibited.
            </p>
          </div>
          <nav
            aria-label="Legal navigation"
            className="flex items-center justify-center sm:justify-end gap-x-5 gap-y-2 flex-wrap pt-1"
          >
            <Link
              to="/privacy"
              data-testid="footer-link-privacy"
              className="hover:text-[var(--sd-primary-dark)] hover:underline font-medium whitespace-nowrap"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-link-terms"
              className="hover:text-[var(--sd-primary-dark)] hover:underline font-medium whitespace-nowrap"
            >
              Terms &amp; Conditions
            </Link>
            <Link
              to="/support"
              data-testid="footer-link-support"
              className="hover:text-[var(--sd-primary-dark)] hover:underline font-medium whitespace-nowrap"
            >
              Support
            </Link>
            <Link
              to="/trademarks"
              data-testid="footer-link-trademarks"
              className="hover:text-[var(--sd-primary-dark)] hover:underline font-medium whitespace-nowrap"
            >
              Trademarks
            </Link>
            <Link
              to="/delete-account"
              data-testid="footer-link-delete"
              className="hover:text-[var(--sd-primary-dark)] hover:underline font-medium whitespace-nowrap"
            >
              Delete Account
            </Link>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
